import React, {useContext, useState} from "react";
import {Tab, Tabs} from "@material-ui/core";
import ContextMenu from "./ContextMenu";
import TabContainer from "./TabContainer";
import TabPanel from "./TabPanel";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import makeStyles from "@material-ui/styles/makeStyles";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../../JsonScreen/Utils/lib";

const initialContextState = {
    mouseX: null,
    mouseY: null,
};
const tabSource = {
    type: 'tab',
    properties: {label: 'New Tab'},
    styles: [{color: ''}],
    children: [
        {
            type: 'panel',
            styles: [{
                width: "100%",
                padding: "0px",
                margin: "",
                minHeight: "50px",
                textAlign: '',
                flexGrow: 0
            }],
            children: [
                {
                    type: 'panel',
                    styles: [{
                        width: "100%",
                        padding: "0px",
                        margin: "",
                        minHeight: "50px",
                        textAlign: '',
                        flexGrow: 0
                    }],
                    children: [],
                }
            ],
        }
    ]
};
const useStyles = makeStyles(() => ({
    tabWrapper: {
        alignItems: props => props.alignTabText || 'center'
    },
    selectedTab: {
        background: '#f7f7f7'
    }
}))
const TabsComponent = ({component, path}) => {
    const {
        onDeleteComponent,
        onSelectComponent,
        onDropComponent
    } = useContext(ScreenDesignerContextNew);
    const [value, setValue] = useState(0);
    const [anchorEl, setAnchorEl] = useState(initialContextState);
    const [editTab, setEditTab] = useState({index: null, source: null});
    const {userLanguage} = useSelector(state => state.app);
    const {styles: sourceStyles, children} = component;
    const styles = sourceStyles.length ? sourceStyles[0] : {};
    const classes = useStyles({alignTabText: styles.alignTabText});

    function handleChange(e, newValue) {
        setValue(newValue)
    }

    function openTabContext(event, source, index) {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        });
        setEditTab({index, source})
    }

    function onTabClick(event, source, index) {
        event.stopPropagation();
        onSelectComponent(source, `${path}.children.${index}`)
    }

    function closeTabContext() {
        setAnchorEl(initialContextState);
        setEditTab({index: null, source: null})
    }

    function onEditTab() {
        onSelectComponent(editTab.source, `${path}.children.${editTab.index}`)
    }

    function onRemoveTab() {
        onDeleteComponent(`${path}.children.${editTab.index}`, editTab.source.type,)
    }

    function addAfter() {
        onDropComponent(tabSource, editTab.index + 1, `${path}.children`)
    }

    function addBefore() {
        onDropComponent(tabSource, editTab.index, `${path}.children`)
    }
    function duplicateTab() {
        onDropComponent(editTab.source, editTab.index + 1, `${path}.children`)
    }

    return (
        <div style={{
            width: '100%',
            height: '100%',
            margin: styles.margin,
            display: styles.orientation === 'vertical' ? 'flex' : 'block'
        }}>
            <div style={{
                background: styles.background,
                boxShadow: `${styles.boxShadow} ${styles.shadowColor}`,
            }}>
                <Tabs
                    indicatorColor={styles.indicatorColor}
                    value={value}
                    onChange={handleChange}
                    orientation={styles.orientation || 'horizontal'}
                    style={{minHeight: 30}}
                >
                    {children.map((tab, index) => {
                        const tabStyles = tab.styles.length ? tab.styles[0] : {};
                        const multiLanguageLabel = multiLanguageValue(tab.properties.label, userLanguage)
                        return (
                            <Tab
                                key={index}
                                color={tabStyles.color}
                                label={multiLanguageLabel}
                                style={{minHeight: 30}}
                                classes={{
                                    wrapper: classes.tabWrapper,
                                    selected: classes.selectedTab
                                }}
                                onContextMenu={(e) => openTabContext(e, tab, index)}
                                onClick={(e) => onTabClick(e, tab, index)}
                            />
                        )
                    })}
                </Tabs>
            </div>
            {children.map((tab, index) => {
                return (
                    <TabPanel
                        key={index}
                        value={value}
                        index={index}
                        orientation={styles.orientation}
                    >
                        <TabContainer
                            component={tab}
                            index={index}
                            path={path}
                        />
                    </TabPanel>
                )
            })}
            <ContextMenu
                anchorEl={anchorEl}
                onClose={closeTabContext}
                duplicateItem={duplicateTab}
                addAfter={addAfter}
                addBefore={addBefore}
                edit={onEditTab}
                remove={onRemoveTab}
                index={editTab.index}
                itemsCount={children.length}
            />
        </div>
    )
};
export default TabsComponent;